import Swiper from 'swiper';
import { Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const swiper = {
    activeSwipers: [],
    init() {
        const self = this;
        const swipers = document.querySelectorAll('.swiper');

        if (swipers.length) {
            swipers.forEach((swiper) => {
                const pagination = swiper.querySelector('.swiper-pagination');

                self.activeSwipers.push(new Swiper(swiper, {
                    modules: [Pagination, EffectFade],
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    pagination: {
                        el: pagination,
                        clickable: true,
                    },
                }));
            });
        }

    },
};

export default swiper;
